/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';

@Component({
  standalone: false,
  selector: 'gh-grid-text-cell-editor',
  templateUrl: 'grid-text-cell-editor.component.html',
  styleUrls: ['grid-input-cell-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTextCellEditorComponent extends AbstractGridInputCellEditorComponent {
}
